import React from 'react';

import { Button, Modal } from '@shared/components/bootstrap';

import { CONSENT_INFO, ConsentField } from './types';

interface ConsentInfoModalProps {
  field: ConsentField;
  onClose: () => void;
}

/**
 * Modal component that displays information about a consent field.
 *
 * @param props - The component props.
 * @returns The ConsentInfoModal component.
 */
export const ConsentInfoModal: React.FC<ConsentInfoModalProps> = ({ field, onClose }) => {
  const info = CONSENT_INFO[field];

  return (
    <Modal onClose={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{info.title}</Modal.Title>
          <Modal.Close close={onClose} />
        </Modal.Header>
        <Modal.Body>{info.content}</Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
